import { useMemo, useRef } from 'react';
import useSWR              from 'swr';

import { SERVICES }                                   from '@shared/constants/apiConfig';
import { ILenderELTCode, TLenderELTSpecificEltCodes } from '../interfaces';

export const useLenderELTCodes = () => {
	const lenders        = useRef<{ id: string; name: string }[]>([]);
	const lenderELTCodes = useRef<TLenderELTSpecificEltCodes[]>([]);

	const { data, mutate, error } = useSWR(`/${SERVICES.LENDER}/lenders/eltcodes`);

	if (data) {
		const codes = (data as ILenderELTCode[]).reduce(
		(acc: TLenderELTSpecificEltCodes[], curr: ILenderELTCode, index) => {
			lenders.current.push({ id: curr.lenderId, name: curr.name });

				return [
					...acc,
					...curr.stateSpecificEltCodes.map((code, mapIndex) => ({
						...code,
						lenderId : curr.lenderId,
							id       : `${curr.lenderId}${curr?.code ? `_${curr.code}` : ''}${code?.eltCode ? `_${code?.eltCode}` : ''}${code?.lenderAddress ? `_${code.lenderAddress}` : ''}_${index}_${mapIndex}`,
							name     : curr.name,
							eltCode  : code.eltCode,
						}
					)),
				];
			}, []);

		lenderELTCodes.current = codes;
	}

	const sortedLenderEltCodes = useMemo(() => lenderELTCodes.current.sort((a, b) => a.name.localeCompare(b.name)), [lenderELTCodes.current]);

	return {
		error,
		lenders               : lenders.current,
		lenderELTCodes        : sortedLenderEltCodes,
		refetchLenderELTCodes : mutate,
	};
};
